<template>
    <div
        class="wrap app_notice"
        :class="{
            app_notice_student: $isIamschoolStudent,
            app_notice_parents: $isIamschoolParent,
        }"
    >
        <div v-if="isDoneLoadInitData && questions && !!questions.length">
            <component :is="headerComponent" :isPreview="isPreview" v-show="!isWebView"/>

            <div class="content survey" :class="{parents: $isIamschoolParent}">
                <ResponseTitle
                    :alert-text="isBeforeEnrolment ? this.$t('EnrolmentResponseDefault_noApplyDate') : isEndEnrolment ? this.$t('EnrolmentResponseDefault_endedApply') : null"
                    :period-text="isBeforeEnrolment && periodText"
                    :title="survey.title"
                    :writer="survey.schoolName"
                    :send-date-string="survey.sendDate"
                    :modify-date-string="survey.modifyDate"
                    :is-modified="survey.modified"
                />

                <ResponseDescText
                    :survey-desc="surveyDesc"
                        :images="surveyImages"
                        @clickPreviewImage="showImage"
                        :is-webview="isWebView"
                />

                <ResponseFile
                        :documents="surveyDocuments"
                />

                <div class="after_survey_area" @click.prevent="preventClickForIosTouch">
                    <div class="after_tit_area">
                        <div class="tit_bx">
                            <h2 class="tit">
                                <span class="txt">{{$t('EnrolmentResponse_enrolmentInfo')}}</span>
                            </h2>
                        </div>
                    </div>
                    <ul class="info_detail">
                        <li>
                            <span class="info_tit">{{$t('EnrolmentResponse_responseTarget')}} :</span>
                            <span class="info_txt"><HangulWordWrapText :text="survey.receiverName" :split-regex="/, +/" inter-text=", " /></span>
                        </li>
                        <li>
                            <span class="info_tit" v-if="isBeforeEnrolment">{{$t('EnrolmentResponse_startAt')}} :</span>
                            <span class="info_tit" v-else>{{$t('EnrolmentResponse_endAt')}} :</span>
                            <span class="info_txt">
                                <span class="status_txt" v-if="!isEndEnrolment" :class="{end: !isBeforeEnrolment}">{{remainDaysText}}<br></span>
                                <span class="time">
                                    <template v-if="isBeforeEnrolment">
                                        {{$t('EnrolmentResponse_startAtDesc', {datetime: startDateString})}}
                                    </template>
                                    <template v-else>
                                        {{$t('EnrolmentResponse_endAtDesc', {datetime: endDateString})}}
                                    </template>
                                    <span class="badge" v-if="isEndEnrolment">{{$t('EnrolmentResponse_ended')}}</span>
                                </span>
                            </span>
                        </li>
                        <li>
                            <span class="info_tit">{{$t('EnrolmentResponse_selectionMethod')}} :</span>
                            <span class="info_txt"><strong>{{enrolmentTypeName}}</strong></span>
                        </li>
                    </ul>
                    <div
                        v-if="isShowDrawPriorInfo"
                        class="info_lottery"
                    >
                        <strong class="tit">{{$t('EnrolmentResponse_drawPriorsTitle')}}</strong>
                        <ul>
                            <li>{{$t('EnrolmentResponse_drawPriorsDesc1')}}</li>
                            <li>{{$t('EnrolmentResponse_drawPriorsDesc2')}}</li>
                            <li>{{$t('EnrolmentResponse_drawPriorsDesc3')}}</li>
                        </ul>
                    </div>
                    <form action="#">
                        <fieldset>
                            <legend>{{$t('EnrolmentResponse_blind_surveyArea')}}</legend>

                            <EnrolmentResponseAgreementList
                                v-if="agreements && agreements.length > 0"
                                ref="agreementsResponse"
                                @change-answer-state="changeAnswerState"/>

                            <div v-if="!isEndEnrolment">
                                <div class="after_tit_area">
                                    <div class="tit_bx">
                                        <h2 class="tit">
                                            <span class="txt">{{$t('EnrolmentResponse_confirmApplyEnrolment')}}</span>
                                            <IconRequired/>
                                        </h2>
                                    </div>
                                </div>
                                <div class="bx_lst_checkbox">
                                    <ul class="lst_checkbox">
                                        <li>
                                            <span class="bx_input">
                                                <input type="radio" name="apply_option" id="apply_option1" class="inp_rdo" :checked="answerStateType === answerStateTypeDeny">
                                                <label for="apply_option1" class="txt_checkbox" @click="changeAnswerState(answerStateTypeDeny, $event)">{{$t('EnrolmentResponse_doNotApply')}}</label>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="bx_input">
                                                <input type="radio" name="apply_option" id="apply_option2" class="inp_rdo" :checked="answerStateType === answerStateTypeAnswer">
                                                <label for="apply_option2" class="txt_checkbox" @click="changeAnswerState(answerStateTypeAnswer, $event)">{{$t('EnrolmentResponse_doApply')}}</label>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <EnrolmentResponseQuestion v-for="question in questions" :key="question.questionNo" :question="question"></EnrolmentResponseQuestion>
                        </fieldset>
                    </form>
                </div>

                <!-- Confirm Vue (신청하지 않겠습니다 선택시) -->
                <div class="confirmVue" v-responseModal="isAllCancelConfirm">
                    <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
                        <div class="layer_box">
                            <div class="layer_content">
                                <em class="tit" v-html="$t('EnrolmentResponse_confirmCancelApply')"></em>
                                <p class="desc" v-html="$t('EnrolmentResponse_confirmCancelApplyDesc')"></p>
                            </div>
                            <!-- [D] 좌우 버튼의 크기가 다를 경우 type2 추가 -->
                            <ul class="btn_area type2">
                                <li>
                                    <button type="button" class="btn btn_gray" @click="confirmDenyNo">
                                        {{ $t('common_no') }}
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="btn" @click="confirmDenyYes">
                                        {{ $t('EnrolmentResponse_cancelApply') }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Alert Vue (동의하지 않습니다 선택시) -->
                <div class="alertVue" v-responseModal="isShowAgreementAlert">
                    <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
                        <div class="layer_box">
                            <div class="layer_content">
                                <em class="tit">
                                    강좌 신청 완료 후에는 개인정보 수집 및 이용 동의를 변경할 수 없습니다
                                </em>
                            </div>
                            <ul class="btn_area">
                                <li>
                                    <button type="button" class="btn" @click.stop="onClickAgreementAlertOk">{{$t('common_confirm')}}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Confirm Vue (동의사항을 모두 동의하지 않은 상태로 수강 신청 시) -->
                <div class="confirmVue" v-responseModal="isAllAgreementsConfirm">
                    <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
                        <div class="layer_box">
                            <div class="layer_content">
                                <p class="desc">
                                    수강신청을 하려면 모든 개인정보 수집 및 이용 항목에 동의해야 합니다. 모두 동의하시겠습니까?
                                </p>
                            </div>
                            <!-- [D] 좌우 버튼의 크기가 다를 경우 type2 추가 -->
                            <ul class="btn_area type2">
                                <li>
                                    <button type="button" class="btn btn_gray" @click="confirmAllAgreementsCancel">
                                        {{$t('common_no')}}
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="btn" @click="confirmAllAgreementsOk">
                                        동의합니다
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Confirm Vue (페이지 이탈시) -->
                <div class="confirmVue" v-responseModal="isPageUnloadConfirm">
                    <div class="layer_wrap" :class="{parents: $isIamschoolParent}">
                        <div class="layer_box">
                            <div class="layer_content">
                                <em class="tit">{{ $t('EnrolmentResponse_thereIsAvailablePrograms') }}</em>
                                <p class="desc" v-html="$t('EnrolmentResponse_thereIsAvailableProgramsDesc')"></p>
                            </div>
                            <!-- [D] 좌우 버튼의 크기가 다를 경우 type2 추가 -->
                            <ul class="btn_area type2">
                                <li>
                                    <button type="button" class="btn btn_gray" @click="confirmPageUnloadNo">
                                        {{ $t('common_no') }}
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="btn" @click="confirmPageUnloadYes">
                                        {{ $t('EnrolmentResponse_goToFeeds') }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- 전체화면 에러 -->
        <FullScreenError :error="error" v-show="hasFullScreenError"></FullScreenError>

    </div>
</template>

<script>
import {ENROLMENT_TYPE, PERIOD_STATE_TYPE, SURVEY_OPTION_TYPE} from '@/common/consts/survey.js';
import {ERROR_TYPE} from '@/iamteacherpc/consts/errorType.js';

import {getDiffDays, toDateFromISOFormat, toResponseViewFormat} from '@/common/utils/date.js';
import {schema} from '@/common/utils/webview.js';
import {showToast} from '@/common/utils/simpleToast.js';
import {
    checkUserAgent,
    IAMSCHOOL_AOS_APP_DOWNLOAD_URL,
    IAMSCHOOL_IOS_APP_DOWNLOAD_URL,
    IOS,
} from '@/iamteacherpc/utils/checkMobileDevice.js';
import {responseModal} from '@/common/directives/responseModal.js';

import EnrolmentResponseQuestion from '@/iamteacherpc/components/response/EnrolmentResponseQuestion.vue';
import FullScreenError from '@/iamteacherpc/components/common/FullScreenError.vue';
import {createNamespacedHelpers} from 'vuex';
import responsePage from '@/iamteacherpc/mixins/responsePage.js';
import ResponseTitle from '@/iamteacherpc/components/response/ResponseTitle.vue';
import ResponseDescText from '@/iamteacherpc/components/response/ResponseDescText.vue';
import {ENROLMENT_RESPONSE_NAMESPACE} from '@/common/store';
import {
    CHANGE_ANSWER_STATE, CHECK_ALL_AGREEMENTS,
    FORCE_CLOSE,
    GET_ENROLMENT_TYPE_NAME,
    INIT_ENROLMENT_DATA,
    IS_AFTER_ENROLMENT_PERIOD,
    IS_ALL_AGREEMENTS_CHECKED,
    IS_AVAILABLE_ENROLMENT_PERIOD,
    SHOW_ERROR,
    UNCHECK_ALL_AGREEMENTS,
} from '@/common/store/modules/enrolment/response.js';
import ResponseFile from '@/iamteacherpc/components/response/ResponseFile.vue';
import HangulWordWrapText from '@/common/components/HangulWordWrapText.vue';
import {SURVEY_ANSWER_STATE_TYPE} from '@/common/consts/response.js';
import responseApi from '@common/apis/survey/responseApi';
import drawResultApi from '@common/apis/enrolment/drawResultApi';
import enrolmentUtil from '@iamteacherpc/utils/enrolmentUtil.js';
import EnrolmentResponseAgreement from '@iamteacherpc/components/response/EnrolmentResponseAgreement.vue';
import IconRequired from '@iamteacherpc/assets/common/icon/IconRequired.vue';
import EnrolmentResponseAgreementList from '@iamteacherpc/components/response/EnrolmentResponseAgreementList.vue';

const {mapActions, mapGetters, mapState} = createNamespacedHelpers(ENROLMENT_RESPONSE_NAMESPACE);

export default {
    name: 'Response',
    components: {
        EnrolmentResponseAgreementList,
        IconRequired,
        EnrolmentResponseAgreement,
        HangulWordWrapText,
        ResponseFile,
        ResponseDescText,
        ResponseTitle,
            EnrolmentResponseQuestion,
            FullScreenError,
        },
        directives: {responseModal},
        mixins: [
            responsePage
        ],

        metaInfo() {
            const title = this.$t('common_enrolment');
            return {title}
        },

        props: {
            serviceId: {
                type: String,
                required: true
            },

            isPreview: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                type: 'enrolment',
                answerStateTypeDeny: SURVEY_ANSWER_STATE_TYPE.DENY,
                answerStateTypeAnswer: SURVEY_ANSWER_STATE_TYPE.ANSWER,
                answerStateTypeNonresponse: SURVEY_ANSWER_STATE_TYPE.NONRESPONSE,
                isAllCancelConfirm: false,
                isPageUnloadConfirm: false,
                isLoadError: false,
                isDoneLoadInitData: false,
                isAllAgreementsConfirm: false,
                isShowAgreementAlert: false,
            }
        },

        computed: {
            ...mapState({
                survey: state => state.survey,
                surveyDesc: state => state.survey.surveyDesc,
                surveyImages: state => state.survey.contents.images,
                surveyDocuments: state => state.survey.contents.documents,
                startDateString: state => toResponseViewFormat(state.survey.startDate),
                endDateString: state => toResponseViewFormat(state.survey.endDate),
                sendDateString: state => toResponseViewFormat(state.survey.sendDate),
                startDate: state => state.survey.startDate,
                endDate: state => state.survey.endDate,
                periodStateType: state => state.survey.periodStateType,
                questions: state => state.survey.contents && state.survey.contents.questions,
                answerStateType: state => state.survey.answerStateType,
                receiverAnswerStateType: state => state.survey.receiver.answerStateType,
                answers: state => state.survey.receiver.surveyAnswers,
                error: state => state.error,
                agreements: state => state.survey.contents.agreements,
                modifyDate: state => state.survey.modifyDate,
                modified: state => state.survey.modified
            }),

            ...mapGetters({
                enrolmentTypeName: GET_ENROLMENT_TYPE_NAME,
                isAvailableEnrolmentPeriod: IS_AVAILABLE_ENROLMENT_PERIOD,
                isEndEnrolment: IS_AFTER_ENROLMENT_PERIOD,
                isAllAgreementsChecked: IS_ALL_AGREEMENTS_CHECKED,
            }),

            isWebView() {
                return this.$route.query.hasOwnProperty('isMasking');
            },

            schoolWebUrl() {
                if (this.isPreview) {
                    return '#';
                }

                return 'https://school.iamservice.net/';
            },

            appDownloadURL() {
                if (this.isPreview) {
                    return '#';
                }

                if (checkUserAgent() === IOS) {
                    return IAMSCHOOL_IOS_APP_DOWNLOAD_URL;
                }
                return IAMSCHOOL_AOS_APP_DOWNLOAD_URL;
            },

            /**
             * 신청상태에 따른 style 적용
             * @Deprecated
             */
            answerStateClass() {
                //신청안함
                if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                    return {};
                }

                //신청완료
                if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.ANSWER && this.answers && this.answers.length > 0) {
                    return {point: true, not: false};
                }

                //미신청
                return {point: true, not: true};
            },

            hasFullScreenError() {
                return this.error.hasError && this.error.errorType === ERROR_TYPE.FULL_SCREEN;
            },

            remainDaysText() {
                if (this.isBeforeEnrolment) {
                    const remainDays = getDiffDays(new Date(), toDateFromISOFormat(this.startDate));

                    if (remainDays > 0) {
                        return this.$t('EnrolmentResponseDefault_startAfterDays', {days: remainDays});
                    } else {
                        return this.$t('EnrolmentResponseDefault_startToday');
                    }
                } else {
                    const remainDays = getDiffDays(new Date(), toDateFromISOFormat(this.endDate));

                    if (remainDays > 0) {
                        return this.$t('EnrolmentResponseDefault_endAfterDays', {days: remainDays});
                    } else {
                        return this.$t('EnrolmentResponseDefault_endToday');
                    }
                }
            },

            periodText() {
                return `${this.$t('EnrolmentResponseDefault_applyDateInfo')} : ${this.startDateString} ~ ${this.endDateString}`;
            },

            isBeforeEnrolment() {
                return this.periodStateType === PERIOD_STATE_TYPE.BEFORE_PERIOD;
            },

            isShowDrawPriorInfo() {
                return this.survey.enrolmentType === ENROLMENT_TYPE.DRAW_PRIOR;
            },
        },

        watch: {
            /*에러 메세지를 toast로 보여주는 경우*/
            error: function (error) {
                if (error.hasError && error.errorType === ERROR_TYPE.POPUP) {
                    showToast(error.resultMessage, this.isWebView);
                }
            }
        },

        methods: {
            ...mapActions({
               changeAnswerStateAction: CHANGE_ANSWER_STATE,
               initEnrolmentData: INIT_ENROLMENT_DATA,
               showError: SHOW_ERROR,
               forceClose: FORCE_CLOSE,
                checkAllAgreements: CHECK_ALL_AGREEMENTS,
                uncheckAllAgreements: UNCHECK_ALL_AGREEMENTS,
            }),

            //IOS에서 빠르게 반복해서 터치시 더블 탭으로 인식되는 문제로 인해 전체영역 click prevent
            preventClickForIosTouch() {
            },

            changeAnswerState(newAnswerStateType, event) {
                if (this.isPreview) {
                    this.changeAnswerStateAction({answerStateType: newAnswerStateType});
                    return;
                }

                if (Date.now() > toDateFromISOFormat(this.endDate)) {
                    event.preventDefault();
                    this.forceClose();
                    return;
                }

                if (newAnswerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                    event.preventDefault();
                }

                if (this.answerStateType === newAnswerStateType) {
                    return;
                }

                if (newAnswerStateType === SURVEY_ANSWER_STATE_TYPE.DENY && this.answers.length > 0) {
                    this.isAllCancelConfirm = true;
                    return;
                }

                if (newAnswerStateType === SURVEY_ANSWER_STATE_TYPE.ANSWER && !this.isAllAgreementsChecked) {
                    this.isAllAgreementsConfirm = true;
                    return;
                }

                if (newAnswerStateType === SURVEY_ANSWER_STATE_TYPE.DENY) {
                    this.uncheckAllAgreements();
                }
                this.changeAnswerStateAction({answerStateType: newAnswerStateType});
            },

            confirmDenyNo() {
                this.isAllCancelConfirm = false;
            },
            confirmDenyYes() {
                this.changeAnswerStateAction({answerStateType: SURVEY_ANSWER_STATE_TYPE.DENY})
                    .then(() => {
                        this.uncheckAllAgreements();
                        this.isAllCancelConfirm = false;
                        showToast(this.$t('EnrolmentResponseDefault_allEnrolmentCanceled'), this.isWebView);
                    });
            },

            confirmAllAgreementsCancel() {
                this.isAllAgreementsConfirm = false;
            },
            confirmAllAgreementsOk() {
                this.changeAnswerStateAction({answerStateType: SURVEY_ANSWER_STATE_TYPE.ANSWER})
                    .then(() => {
                        this.checkAllAgreements();
                        this.isAllAgreementsConfirm = false;
                    });
            },
            onClickAgreementAlertOk() {
                this.isShowAgreementAlert = false;
            },

            /**
             * 페이지 이탈방지 설정
             *
             */
            setPageUnload() {
                if (this.isPreview) {
                    return;
                }

                window.onbeforeunload = event => {
                    if (this.isAvailableAnswer()) {
                        event.returnValue = '';
                    }
                };

                // 웹뷰용 이탈 방지
                window.onWebviewClose = () => {
                    if (this.isAvailableAnswer()) {
                        this.isPageUnloadConfirm = true;
                        return;
                    }
                    schema('webview', 'close');
                };
            },

            // 웹뷰용 이탈 방지 confirm NO
            confirmPageUnloadNo() {
                this.isPageUnloadConfirm = false;
            },
            // 웹뷰용 이탈 방지 confirm YES
            confirmPageUnloadYes() {
                schema('webview', 'close');
                this.isPageUnloadConfirm = false;
            },

            //신청가능한 강좌가 존재하는지 여부
            isAvailableAnswer() {
                //신청하겠습니다 선택이 아닌경우 (미신청, 신청하지 않겠습니다 선택인경우)
                if (this.answerStateType !== SURVEY_ANSWER_STATE_TYPE.ANSWER) {
                    return false;
                }
                //신청기간
                if (!this.isAvailableEnrolmentPeriod) {
                    return false;
                }

                //최대선택갯수 미만으로 선택한 수강신청들
                let availableAnswerQuestions = [];
                const allowDuplicateApply = this.survey.options.find(option => option.optionType === SURVEY_OPTION_TYPE.ALLOW_APPLY_DUPLICATE)?.optionValue !== 'false';
                if (!allowDuplicateApply) {
                    availableAnswerQuestions = enrolmentUtil.getAvailableProgramsWhenAllowDuplicateApply(this.questions[0].programs);
                } else {
                    availableAnswerQuestions = this.questions.filter(question => {
                        //해당 수강신청의 프로그램 전부 신청
                        if (question.choiceCount >= question.programs.length) {
                            return false;
                        }
                        return question.maxChoice === 0 || (question.maxChoice > question.choiceCount);
                    });

                }

                if (availableAnswerQuestions.length === 0) {
                    return false;
                }

                //추첨인 경우 정원 확인할 필요없음
                if (this.survey.enrolmentType === ENROLMENT_TYPE.RANDOM) {
                    return true;
                }

                //가능한 수강신청의 프로그램중 수신자가 신청도 안했고 && 정원마감이 아닌프로그램이 존재
                return availableAnswerQuestions.find(question => question.programs.find(program => {
                    return !program.answer && (program.limit + program.reservedLimit > program.answerTotalCount);
                }));
            },
        },

        created() {
            this.isDoneLoadInitData = true;
            if (!this.questions.length) {
                this.showError({
                    hasError: true,
                    errorType: ERROR_TYPE.FULL_SCREEN,
                    resultCode: 0,
                    resultMessage: this.$t('EnrolmentResponseDefault_noTargetGrade'),
                });
                return;
            }

            if (!this.survey.receiver.isRead) {
                // 읽음처리 API는 응답을 기다리지 않음
                responseApi.patchSurveyReceiverRead({
                    surveyNo: this.survey.surveyNo,
                    surveyReceiverNo: this.survey.receiver.surveyReceiverNo,
                });
            }

            // 티처 읽음처리
            if (this.survey.draw?.actualDrawDateTime) {
                // 읽음처리 API는 응답을 기다리지 않음
                drawResultApi.patchDrawResultRead({
                    enrolmentNo: this.$route.query.surveyReferenceNo,
                    receiverNo: this.$route.query.r,
                });
            }
        },

        mounted() {
            this.setPageUnload();
        },
    }
</script>
